module.exports = __webpack_public_path__ + "af.339e13117be1ba0b85b4.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/af.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/af.svg
// module chunks = styles